// extracted by mini-css-extract-plugin
export var chip = "_redotech-redo-web-src-chip-input-chip";
export var chipLabel = "_redotech-redo-web-src-chip-input-chip-label";
export var close = "_redotech-redo-web-src-chip-input-close";
export var closeIcon = "_redotech-redo-web-src-chip-input-close-icon";
export var error = "_redotech-redo-web-src-chip-input-error";
export var infoTooltip = "_redotech-redo-web-src-chip-input-info-tooltip";
export var innerContainer = "_redotech-redo-web-src-chip-input-inner-container";
export var input = "_redotech-redo-web-src-chip-input-input";
export var medium = "_redotech-redo-web-src-chip-input-medium";
export var outerContainer = "_redotech-redo-web-src-chip-input-outer-container";
export var small = "_redotech-redo-web-src-chip-input-small";
export var xSmall = "_redotech-redo-web-src-chip-input-x-small";